import RollPowerLaunch from '../../components/RollPowerLaunch/RollPowerLaunch';
import './TiebreakerPreRoll.css';

const Tiebreaker = ({ handleTiebreaker, tiebreakerState }) => (
  <RollPowerLaunch
    onRoll={handleTiebreaker}
    to="/multi/tiebreaker/post-roll"
    variant="tiebreaker"
  >
    {() => (
      <section
        className="tiebreakerRoster"
        aria-labelledby="tiebreaker-roster-title"
      >
        <div className="tiebreakerRoster__header">
          <div>
            <p className="tiebreakerRoster__signal">DEADLOCK DETECTED</p>
            <h2 id="tiebreaker-roster-title">Players in tiebreaker</h2>
          </div>
          <span className="tiebreakerRoster__count">
            {String(tiebreakerState.length).padStart(2, '0')} CONTENDERS
          </span>
        </div>
        <ul className="tiebreakerRoster__grid">
          {tiebreakerState.map((player, index) => (
            <li className="tiebreakerContender" key={player.id}>
              <span className="tiebreakerContender__slot" aria-hidden="true">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="tiebreakerContender__identity">
                <span className="tiebreakerContender__label">
                  {'CONTENDER // READY'}
                </span>
                <h3>{player.name}</h3>
              </div>
              <span
                className="tiebreakerContender__target"
                aria-hidden="true"
              />
            </li>
          ))}
        </ul>
        <p className="tiebreakerRoster__footer">
          <span aria-hidden="true">{'//'}</span> SAME SCORE. NEW SHOT AT THE CROWN.
        </p>
      </section>
    )}
  </RollPowerLaunch>
);

export default Tiebreaker;
